<template>
  <div class="signContractCreate">
    <el-steps :active="active" finish-status="success" align-center>
      <el-step v-for="item of stepsList" :title="item.title" :key="item.id" />
    </el-steps>
    <keep-alive>
      <component
        :feeList="feeList"
        class="component"
        @cancel="cancel"
        @confirm="confirm"
        @previousStep="previousStep"
        :active="active"
        :topPreviewModel="topPreviewModel"
        :is="stepsList[active].components"
      />
    </keep-alive>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { getRentOrderConfig } from '@/api/purchaseAndSaleAPI'
import config from './config'

export default {
  provide() {
    return {
      isAdd: true, // 当前页面为新增,
      getOrderConfigInfo: () => this.orderConfigData,
    }
  },
  data() {
    const {
      // 进度条
      stepsList,
    } = config.call(this)
    return {
      stepsList,
      topPreviewModel: {}, // 顶部预览
      active: 0,
      orderConfigData: {},
      feeList: [],
    }
  },
  watch: {
  // 利用watch方法检测路由变化：
    $route(to, from) {
      if (to.fullPath !== from.fullPath) {
        this.init()
      }
    },
  },
  created() {
    this.init()
  },
  methods: {
    // 取消
    cancel() {
      this.$refreshBack(this.active >= 3)
    },
    // 上一步
    previousStep(orderId) {
      this.active--
      if (orderId) this.getRentOrderConfigInfo(orderId)
    },
    // 确认，下一步
    confirm(step, list) {
      this.active = step
      if (Array.isArray(list)) {
        this.feeList = list
      }
    },
    init() {
      // leadPhone: 线索手机号, leadName： 线索姓名
      const { orderId, stepsActive, leadPhone, leadName, leadId } = this.$route.query
      this.topPreviewModel.orderId = orderId || ''
      this.topPreviewModel.leadPhone = leadPhone || ''
      this.topPreviewModel.leadName = leadName || ''
      this.topPreviewModel.leadId = leadId || ''
      this.active = Number(stepsActive) || 0
    },
    // 获取订单配置数据
    async getRentOrderConfigInfo(orderId) {
      const { data } = await getRentOrderConfig({ orderId })
      const { orderAccruedPlans = [] } = data
      this.orderConfigData = {
        ...data,
        orderAccruedPlans: orderAccruedPlans?.map((item) => {
          return {
            ...item,
            amount: item.planAmount,
            isConfirm: true,
            name: item.fundTypeName,
          }
        }),
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.signContractCreate {
  margin-top: 20px;
  margin-right: 16px;
  .component {
    margin-top: 40px;
  }
}
</style>
